module.exports = __webpack_public_path__ + "img/FR12818.0d711261.png";